import React from "react";
import { Box, Typography, Button } from "@mui/material";
import clsx from "clsx";
import WhatsAppIcon from "src/assets/images/settings/whatsapp_logo.png";
import useStyle from "./Styles";

interface IExternalPage {
  handleClick: any;
  handleOpenInstructions: () => void;
  isCollapsed: boolean;
}

const NotConnectedBox: React.FC<IExternalPage> = ({
  handleClick,
  handleOpenInstructions,
  isCollapsed,
}) => {
  const { classes } = useStyle();
  return (
    <Box className={clsx(classes.cardWrapper, isCollapsed && "collapsed")}>
      <Box className={clsx(classes.contentBox, isCollapsed && "collapsed")}>
        <Box
          className={clsx(classes.iconContainer, isCollapsed && "collapsed")}
        >
          <img
            src={WhatsAppIcon}
            alt="whatsapp icon"
            className={classes.waIcon}
          />
        </Box>

        <Typography
          variant="h6"
          className={clsx(classes.mainTitle, isCollapsed && "collapsed")}
        >
          {isCollapsed ? "WhatsApp" : "Connect your WhatsApp Account"}
        </Typography>

        {!isCollapsed && (
          <Typography className={classes.description}>
            Connect your WhatsApp Business account to manage your communication
            and messages seamlessly.
          </Typography>
        )}

        <Button
          variant="contained"
          onClick={handleClick}
          className={clsx(classes.waAccConnectBtn, isCollapsed && "collapsed")}
        >
          Connect Account
        </Button>

        {!isCollapsed && (
          <Button
            variant="text"
            onClick={handleOpenInstructions}
            className={classes.howItWorksBtn}
          >
            How it works?
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default NotConnectedBox;
